import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouseLaptop = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.13973 3.23175C7.48567 2.92275 8.01723 2.92275 8.36035 3.23175L14.2103 8.48201C14.3988 8.65155 14.5 8.88671 14.5 9.12462H10.45C9.91285 9.12462 9.4291 9.35431 9.10004 9.718V8.68709C9.10004 8.44646 8.89754 8.24957 8.65004 8.24957H6.85004C6.60254 8.24957 6.40005 8.44646 6.40005 8.68709V10.4372C6.40005 10.6778 6.60254 10.8747 6.85004 10.8747H8.65004V14.3749H4.15005C3.40474 14.3749 2.80006 13.787 2.80006 13.0623V9.99966H1.90006C1.52881 9.99966 1.19694 9.77816 1.06194 9.44455C0.92694 9.11094 1.01694 8.72811 1.28975 8.48201L7.13973 3.23175ZM10.9 11.3122V15.2499H16.3V11.3122H10.9ZM9.55003 10.8747C9.55003 10.3907 9.95222 9.99966 10.45 9.99966H16.75C17.2478 9.99966 17.65 10.3907 17.65 10.8747V15.2499H18.55C18.7975 15.2499 19 15.4468 19 15.6874C19 16.4121 18.3953 17 17.65 17H16.3H10.9H9.55003C8.80472 17 8.20004 16.4121 8.20004 15.6874C8.20004 15.4468 8.40254 15.2499 8.65004 15.2499H9.55003V10.8747Z",
		fill: "#0D2976"
	})
});
export default SvgHouseLaptop;
